import React, { useState, useEffect, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import FormHelperText from '@material-ui/core/FormHelperText';
import SelectDevices from '../../../../../components/FormInputs/SelectDevices';
import SelectUserTypes from '../../../../../components/FormInputs/SelectUserTypes';
import API from '../../../../../api/axios';

const AddForm = (props) => {
  const { showMessage, onSubmit, edit, onCancelEdit } = props;
  const [state, setState] = useState({});
  const [errors, setErrors] = useState({});
  const error = useRef({});
  const { title, description, order, devices, users } = state;
  const handleChangeDevices = (devices) => {
    setState({
      ...state,
      devices,
    });
  };
  const handleChangeUserTypes = (userTypes) => {
    setState({
      ...state,
      users: userTypes,
    });
  };
  const handleChangeField = (e) => {
    const { value, name } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };
  const validation = () => {
    error.current = {};
    !title && (error.current.title = 'عنوان اسلایدر را وارد کنید.');
    !description && (error.current.description = 'شرح اسلایدر را وارد کنید');
    !order && (error.current.order = 'عدد ترتیب قرارگیری اسلایدر را وارد کنید');
    (!devices || devices.length === 0) &&
      (error.current.devices = 'حداقل یک دیوایس را انتخاب کنید.');
    (!users || users.length === 0) &&
      (error.current.users = 'حداقل یک نوع کاربر بایستی انتخاب شود');
    if (Object.entries(error.current).length > 0) {
      return false;
    }
    return true;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validation()) {
      try {
        let data = {
          ...state,
          devices: state.devices.map((device) => device.value),
          users: state.users.map((user) => user.value),
        };
        if (!!edit) {
          await API.put(`/api/v1/admin/slider/${edit._id}`, data);
          showMessage(1, '', '', 'اسلایدر ویرایش شد.');
        } else {
          await API.post(`/api/v1/admin/slider`, data);
          showMessage(1, '', '', 'اسلایدر اضافه شد.');
        }
        setState({});
        onSubmit();
      } catch (error) {
        console.error(error);
      }
    } else {
      setErrors(error.current);
    }
  };
  const handleCancelEdit = () => {
    setState({});
    onCancelEdit();
  };
  useEffect(() => {
    !!edit && setState(edit);
  }, [edit]);
  return (
    <form onSubmit={handleSubmit}>
      <Grid container direction="column" alignItems="stretch" spacing={1}>
        <Grid item>
          <TextField
            variant="outlined"
            type="number"
            label="ترتیب قرارگیری"
            fullWidth
            name="order"
            value={order ? order : ''}
            size="small"
            onChange={handleChangeField}
            helperText={!!errors.order ? errors.order : null}
            error={!!errors.order ? true : false}
          />
        </Grid>
        <Grid item>
          <TextField
            variant="outlined"
            label="عنوان اسلایدر"
            fullWidth
            name="title"
            value={title ? title : ''}
            size="small"
            onChange={handleChangeField}
            helperText={!!errors.title ? errors.title : null}
            error={!!errors.title ? true : false}
          />
        </Grid>
        <Grid item>
          <TextField
            variant="outlined"
            label="شرح اسلایدر"
            fullWidth
            name="description"
            value={description ? description : ''}
            size="small"
            multiline
            rows={4}
            onChange={handleChangeField}
            helperText={!!errors.description ? errors.description : null}
            error={!!errors.description ? true : false}
          />
        </Grid>
        <Grid item>
          <SelectDevices onChange={handleChangeDevices} devices={devices} />
          <FormHelperText error>
            {!!errors.devices ? errors.devices : null}
          </FormHelperText>
        </Grid>
        <Grid item>
          <SelectUserTypes onChange={handleChangeUserTypes} userTypes={users} />
          <FormHelperText error>
            {!!errors.users ? errors.users : null}
          </FormHelperText>
        </Grid>
        <Grid item>
          {!edit ? (
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleSubmit}
            >
              افزودن
            </Button>
          ) : (
            <Grid container spacing={1}>
              <Grid item xs={8}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleSubmit}
                >
                  ویرایش
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={handleCancelEdit}
                >
                  صرفنظر
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </form>
  );
};

export default AddForm;
